<template>
  <div>
    <div>
      <van-cell class="bor-radus line-height-normal">
        <div v-if="flightObj.flyTransfer==true">
          <img
            style="width: 22.08px;height: 22.08px"
            src="~Assets/images/tk/tkQuery/Transit.webp"
          >&nbsp;&nbsp;
        </div>
        <div style="width: 100%">
          <van-row>
            <van-col :span="flightObj.salePrice?17:24">
              <van-row>
                <div>
                  <div>
                    <van-col
                      span="8"
                      class="text-left"
                    >
                      <div class="font20 font-bold text-space-1">
                        {{ flightObj.departTimes || flightObj.departTime }}
                      </div>
                      <div class="font12 pad">
                        <slot name="departCityName" />
                        <span v-if="flightObj.departAirportName == arrSet[0]">
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span
                          v-else-if="flightObj.departAirportName == arrSet[1]"
                          style="color: #f70;"
                        >
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span
                          v-else-if="flightObj.departAirportName == arrSet[2]"
                          style="color: #ea964e;"
                        >
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span
                          v-else-if="flightObj.departAirportName == arrSet[3]"
                          style="color: #c06f29;"
                        >
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span
                          v-else-if="flightObj.departAirportName == arrSet[4]"
                          style="color: #f9c699"
                        >
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span v-else-if="flightObj.departAirportName != arrSet">
                          {{ flightObj.departAirportName|airportName }}
                        </span>
                        <span>{{ flightObj.departTerminal }}</span>
                      </div>
                    </van-col>
                    <van-col
                      span="8"
                      class="font10 text-nowrap gray pad-t-6 text-center"
                    >
                      <slot name="departDate" />
                      <!--时间-->
                      <span v-if="flightObj.flyTransfer==true">{{ flightObj.flyTransferTimeStr }}</span>
                      <span v-else>{{ flightObj.flyTimeStr }}</span>
                      <icon-arrow-line />
                      <!--            <span-->
                      <!--              class="main-color"-->
                      <!--              v-show="flightObj.stopNum>0"-->
                      <!--            >经停</span>-->
                      <span
                        class="main-color"
                        v-if="flightObj.flightType == '1'"
                      >经停</span>
                      <span
                        class="main-color"
                        v-else-if="flightObj.flightType == '2'"
                      >通程</span>
                      <span v-else-if="flightObj.flyTransfer == true">
                        <span
                          class="main-color turn"
                        >转</span>
                        <br>
                        <span
                          class="main-color"
                          style="position: relative;top: -10px;"
                        >{{ flightObj.flyTransferCityName }}</span>
                      </span>
                    </van-col>
                    <van-col
                      span="8"
                      class="text-right"
                    >
                      <div class="font20 font-bold text-space-1">
                        {{ flightObj.arriveTimes || flightObj.arriveTime }}<sup
                          class="font10"
                          v-show="(time(flightObj.arriveDate,flightObj.departDate)||flightObj.travelDay)"
                        >+1</sup>
                      </div>
                      <div class="font12 pad">
                        <slot name="arriveCityName" />
                        {{ flightObj.arriveAirportName|airportName }} {{ flightObj.arriveTerminal }}
                      </div>
                    </van-col>
                  </div>
                </div>
              </van-row>
            </van-col>
            <van-col
              span="7"
              v-if="flightObj.salePrice"
            >
              <div class="font-lg money-color text-right text-space-1">
                <span class="font10">&yen;</span>
                <span class="font20 ">{{ flightObj.salePrice }}</span>
              </div>
              <div
                class="font-lg text-right text-space-1"
                v-if="tkSearchInfo.showchildren"
              >
                <span
                  class="ert"
                  v-if="flightObj.chdSalePrice"
                >儿童&yen;</span>
                <span class="ert">{{ flightObj.chdSalePrice }}</span>
              </div>
            </van-col>
          </van-row>
          <div>
            <div
              v-if="flightObj.flyTransfer == true"
              class="spa"
            >
              <span>
                <img
                  :src="flightObj.transferCarrierLogs[0]"
                  class="airIcon1"
                >
                <span>{{ flightObj.transferCarriers[0] }}</span>
              </span>
              &nbsp;|&nbsp;
              <span>
                <img
                  :src="flightObj.transferCarrierLogs[1]"
                  class="airIcon1"
                >
                <span>{{ flightObj.transferCarriers[1] }}</span>
              </span>
              &nbsp;|&nbsp;
              <span>总{{ flightObj.flyTimeStr }}</span>
            </div>
            <div
              class="van-hairline--top pad-t-10"
              v-else
            >
              <div class="font12 van-ellipsis deep-gray" style="white-space: normal">
                <img
                  v-if="flightObj.airlineImg"
                  :src="flightObj.airlineImg"
                  class="airIcon"
                >
                <img v-else-if="flightObj.airlineName=='龙江航空'" src="~Assets/images/tk/tkList/longjianj.png" class="airIcon">
                {{ flightObj.airlineName }}&nbsp;|&nbsp;{{ flightObj.flightNo }}
                <span v-show="flightObj.planeName">&nbsp;|&nbsp;{{ flightObj.planeName }}</span>
                <span v-show="flightObj.orderNo">&nbsp;|&nbsp;{{ flightObj.orderNo }}</span>
                <span v-show="flightObj.zjsl">&nbsp;|&nbsp;<i class="red">已值机</i></span>
                <span v-if=" flightObj.tkPsgs && flightObj.tkPsgs.length > 0 && shname" >
                  <span>&nbsp;|&nbsp;</span>
                  <span v-for="(name,index) in flightObj.tkPsgs" :key="name.mainOrderId"> 
                    {{ name.psgName }} 
                    <span v-if="(flightObj.tkPsgs.length==1 &&index!=0) || index!=flightObj.tkPsgs.length-1">,</span>
                  </span>
                </span>
                <span
                  class="main-color"
                  v-show="flightObj.sharFlightNo"
                  @click.stop="$dialog.alert({message:'实际乘坐：'+' '+flightObj.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"
                >  {{ $t('C132', '共享') }}</span>
              </div>
            </div>
          </div>
          <div
            class="pad-t-10"
            v-if="flightObj.comparePriceMap"
          >
            <div class="font12 van-ellipsis deep-gray">
              <van-row
                type="flex"
                align="center"
                class="bg-shallowGray shadow full-width font12"
              >
                <van-col
                  span="6"
                  class="text-left pad5"
                >
                  <span v-if="flightObj.comparePriceMap['携程']">OTA￥{{ flightObj.comparePriceMap['携程'] }}</span>
                  <span v-else>OTA暂无</span>
                </van-col>
                <van-col
                  span="9"
                  class="text-center pad5"
                >
                  <span v-if="flightObj.comparePriceMap['官网']">航司官网￥{{ flightObj.comparePriceMap['官网'] }}</span>
                  <span v-else>航司官网暂无</span>
                </van-col>
                <van-col
                  span="9"
                  class="text-right pad5"
                >
                  <span v-if="flightObj.comparePriceMap['IBE']">航司标准价￥{{ flightObj.comparePriceMap['IBE'] }}</span>
                  <span v-else>航司标准价暂无</span>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
  </div>
</template>
<script>
import {Cell} from 'vant'
import iconArrowLine from 'Common/iconArrowLine'
import { mapGetters} from 'vuex'

export default {
  name: 'Flight',
  components: {
    [Cell.name]: Cell,
    iconArrowLine
  },
  props: {
    flightObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
    arrSet: {
      type: Array,
      default: function () {
        return {}
      }
    },
    shname:{ //是否显示乘机人的姓名
      type:Boolean,
      default:false
    }
  },
  data() {
    return {}
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
    }),
  },
  methods: {
    time(start, end) {
      if (start > end) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="less" scoped>
@import '~Assets/styles/business';

.pad {
  padding: 2px 0 6px;
}

.pad-b-10 {
  padding-bottom: 10px;
}

.pad-t-10 {
  padding-top: 10px;
}

.pad-t-6 {
  padding-top: 6px;
}

.bor-radus {
  border-radius: 4px;
}

.line-height-normal {
  line-height: normal;
}

.pad5 {
  padding: 5px;
}

.bg-shallowGray {
  background: #fcfcfc;
}

.turn {
  padding: 0px 5px 0 5px;
  position: relative;
  top: -10px;
  background: white;
}

.spa {
  span {
    color: #616161;
  }
}

.van-cell__value {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.airIcon1 {
  height: 10px;
}

.ert {
  font-size: 12px;
  color: #7b7b7b;
}
</style>
